import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SelectBox } from '../../molecules/select-box';
import { SpotPricePeriod } from '../../shared';

const options = [
  {
    label: (
      <FormattedMessage id="spot.price.period.60min" defaultMessage="60 min" />
    ),
    value: SpotPricePeriod['60M'],
  },
  {
    label: (
      <FormattedMessage id="spot.price.period.15min" defaultMessage="15 min" />
    ),
    value: SpotPricePeriod['15M'],
  },
];

export const SpotPricePeriodSelect = () => {
  return (
    <SelectBox
      title={
        <FormattedMessage
          id="settings.spot.price.period"
          defaultMessage="Časové rozlišení"
        />
      }
      selectVariableId="SP_PRICE_PERIOD"
      options={options}
      fullWidth
    />
  );
};
